import React, { useMemo } from 'react'
import { Slider, SliderHandle, SliderMarker } from '@reach/slider'
import classNames from 'classnames'
import debounce from 'lodash/debounce'
import useFormat from 'modules/react/loan-calculator/hooks/useFormat'

export default function SliderGroup({
  labelLeft,
  labelRight,
  showValueAfterLabelLeft = false,
  postFix = '',
  min = 10,
  max = 60,
  step = 5,
  defaultValue = 20,
  totalMarkers = 12,
  onChange = () => {},
  isPrice = false
}) {
  const { formatPrice } = useFormat()
  const [value, setValue] = React.useState(defaultValue ?? null)

  const handleOnChange = useMemo(() => {
    return debounce((val) => {
      onChange(val)
    }, 200)
  }, [])

  const handleChange = (val) => {
    setValue(val)
    handleOnChange(val)
  }

  return (
    <div className={'lc-input-group'}>
      <div className={'lc-input-group__label'}>
        <p className={'lc-input-group__label-left'}>
          {labelLeft}
          {(showValueAfterLabelLeft && value) && (<span>({value}{postFix})</span>)}
        </p>
        <p className={'lc-input-group__label-right'}>{labelRight}</p>
      </div>
      <div className={'lc-input-group__input'}>
        <Slider
          min={min}
          max={max}
          step={step}
          defaultValue={defaultValue}
          onChange={(val) => handleChange(val)}
        >
          <SliderHandle>
            <span className={classNames('lc-input-group__handle-text', {
              'lc-input-group__handle-text--first': value === min,
              'lc-input-group__handle-text--last': value === max
            })}>
              {isPrice ? formatPrice(value) : value + postFix}
            </span>
          </SliderHandle>
          {new Array(totalMarkers).fill('x').map((x, i) => {
            const markerValue = (i + 1) * step
            return (
              <SliderMarker
                as={'div'}
                key={i}
                value={markerValue}
              >
                <span className={classNames('lc-input-group__marker-text', {
                  'lc-input-group__marker-text--hide': markerValue !== min && markerValue !== max,
                  'lc-input-group__marker-text--first': markerValue === min,
                  'lc-input-group__marker-text--last': markerValue === max,
                  'lc-input-group__marker-text--first--hidden': value === min + step,
                  'lc-input-group__marker-text--last--hidden': value === max - step
                })}>
                  {markerValue}{postFix}
                </span>
              </SliderMarker>
            )
          })}
        </Slider>
      </div>
    </div>
  )
}
